import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

// TODO add color to library
const linkHoverBg = '#EBF6F7';

export const sxStyles = {
  schoolsBg: {
    // TODO add color to library
    backgroundColor: '#F9F9F9',
  },
  headSectionWrap: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  headSectionInner: {
    paddingBottom: '1.5rem',
  },
  navBarInfo: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '624px',
    color: theme.palette.common.black,
  }),
  exploreByTitle: {
    marginRight: '1.5rem',
  },
  mainSectionWrap: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2rem',
  },
};

export const StyledNavBar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '2.5rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const StyledActionPanel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& > button:first-of-type': {
    height: '40px',
    marginTop: '1rem',
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',

    '& > button:first-of-type': {
      marginTop: 0,
      marginLeft: '0.5rem',
    },
  },
}));

export const StyledNavBarTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '1rem',
  marginBottom: '1.5rem',

  [theme.breakpoints.up('xs')]: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

export const StyledSwitcherWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  marginTop: '0.5rem',
  flexDirection: 'column',

  [theme.breakpoints.up('xs')]: {
    alignItems: 'center',
    flexDirection: 'row',
  },
}));

export const StyledExploreByTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '3rem',
  marginRight: 0,
  marginBottom: '1rem',

  [theme.breakpoints.up('xs')]: {
    marginTop: 0,
    marginRight: '1.5rem',
    marginBottom: 0,
  },
}));

export const StyledSwitcher = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '2px',
  fontWeight: 600,
}));

export const StyledSchoolsLink = styled(Link)(({ theme }) => ({
  padding: '0.438rem 1.75rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,

  '&:hover': {
    cursor: 'default',
  },
}));

export const StyledMajorsLink = styled(Link)(({ theme }) => ({
  padding: '0.438rem 1.25rem',
  color: theme.palette.primary.main,

  '&:hover': {
    backgroundColor: linkHoverBg,
  },
}));

export const StyledFavoritesLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '160px',
  height: '40px',
  fontWeight: 600,
  fontSize: theme.typography.button.fontSize,
  padding: '0.25rem',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '2px',
  color: theme.palette.primary.main,
  backgroundColor: linkHoverBg,

  '& > svg:first-of-type': {
    marginRight: '0.625rem',
  },
}));

export const StyledCardViewSwitcherWrap = styled('div')(({ theme }) => ({
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',

  [theme.breakpoints.up('sm')]: {
    marginBottom: '1.75rem',
    overflow: 'visible',
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
}));

export const StyledSchoolCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'initial',
  gap: '2rem',

  [theme.breakpoints.down('md')]: {
    gap: '2rem 3rem',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));
